import React from 'react';
import { Home, Building, Briefcase, Store, MapPin, HelpCircle } from 'lucide-react';

const SpaceTypeStep = ({ value, onChange }) => {
  const options = [
    { id: 'apartment', label: 'Apartment / Flat', icon: Building },
    { id: 'house', label: 'Independent House', icon: Home },
    { id: 'office', label: 'Office / Workspace', icon: Briefcase },
    { id: 'shop', label: 'Shop / Commercial', icon: Store },
    { id: 'plot', label: 'Empty Plot / Land', icon: MapPin },
    { id: 'unsure', label: 'Not sure / No idea', icon: HelpCircle }
  ];

  return (
    <div>
      <h3 className="text-2xl font-bold text-[#232323] mb-2">What type of space are you checking?</h3>
      <p className="text-[#353535] mb-6">This helps us understand the basic structure of your property.</p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {options.map((option) => {
          const Icon = option.icon;
          const isSelected = value === option.id;
          
          return (
            <button
              key={option.id}
              onClick={() => onChange(option.id)}
              className={`p-6 border-2 rounded-xl text-left transition-all hover:shadow-lg ${
                isSelected
                  ? 'border-[#232323] bg-[var(--accent-saffron)]'
                  : 'border-gray-200 hover:border-[#999999]'
              }`}
            >
              <div className="flex items-start gap-4">
                <div className={`p-3 rounded-lg ${
                  isSelected ? 'bg-white' : 'bg-[var(--accent-blue-200)]'
                }`}>
                  <Icon className="w-6 h-6 text-[#232323]" />
                </div>
                <div className="flex-1">
                  <p className={`font-semibold text-lg ${
                    isSelected ? 'text-[#232323]' : 'text-[#353535]'
                  }`}>
                    {option.label}
                  </p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SpaceTypeStep;